/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneLoader from 'base/components/standalone/Loader';

export const DynamicStandaloneLoader = StandaloneLoader;
export type DynamicStandaloneLoaderProps = PropsFromComponent<typeof StandaloneLoader>;

export const DynamicStandaloneLoaderWith = (extras: DynamicStandaloneExtras): typeof StandaloneLoader => {
    return function DynamicStandaloneLoader(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Loader');
        return <StandaloneLoader {...mergeProps({ options: { theme } }, props)} />;
    }
}